import request from '@/utils/request'
const apiPath = '/meet/meetingCategory'
import { downloadBlob } from '@/utils/download'
const meetingCategoryApi = {
  /**
   * 新增【会议分类】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【会议分类】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  batchState(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
  /**
   * 分页查询【会议分类】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee/list', { params: query })
  },
  /**
   * 查询【会议分类】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【会议分类】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【会议分类】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '会议分类列表.xlsx'))
  },
}
export default meetingCategoryApi
